import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  deleteMarketmakingTasks,
  getMarketmakingTriggerTable,
  getPreviewOffers,
  pauseMarketmakingTasks,
  resendMarketmakingTasks,
  resumeMarketmakingTasks,
} from "../../../Requests/marketmaking";
import {
  IGetPreviewOfferResp,
  IMarketmakingTaskTableReport,
} from "../../../Interfaces/marketmaking";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { CommonTableUI } from "../../TableTemplate/common";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseIcon from "@mui/icons-material/Pause";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import EditIcon from "@mui/icons-material/Edit";
import { useAppDispatch } from "../../../App/hooks";
import {
  setMarketmakingAddTaskFormValues,
  setMarketmakingIsEditFlag,
} from "../../../Features/Marketmaking/marketmakingSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import Loading from "../../../Components/Loading/Loading";
import { Packet } from "../../../Interfaces/commonDtos";
import { Header } from "../../../Interfaces/TableInterfaces";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";

interface IPreviewState {
  isOpen: boolean;
  submitFunction: ((e?: any) => void) | null;
}

const MarketmakingTaskTableAdditionalHeader = ({
  onAction,
  selectedRowsIds,
}: IAdditionalHeaderProps) => {
  const bulkPauseHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    pauseMarketmakingTasks(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const bulkPlayHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    resumeMarketmakingTasks(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };
  const resendHandler = () => {
    if (!selectedRowsIds.length) return;
    resendMarketmakingTasks(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const deleteTasksHandler = () => {
    if (!selectedRowsIds.length) return;
    deleteMarketmakingTasks(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell />
      <TableCell>
        <div className="flex flex-row">
          <div
            onClick={selectedRowsIds.length ? bulkPauseHandler : undefined}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PauseIcon
              className={`text-sky-900 cursor-pointer  ${
                selectedRowsIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
          <div
            onClick={selectedRowsIds.length ? bulkPlayHandler : undefined}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PlayCircleIcon
              className={`text-sky-900 cursor-pointer ${
                selectedRowsIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
        </div>
      </TableCell>
      <TableCell></TableCell>
      <TableCell>
        <Button
          onClick={resendHandler}
          className="table-btn"
          text="ارسال مجدد"
          variant="outlined"
          disabled={!selectedRowsIds.length}
        />
      </TableCell>
      <TableCell>
        <div
          className="hover:bg-red-100 transition-all rounded p-1"
          onClick={deleteTasksHandler}
        >
          <DeleteIcon
            fontSize="small"
            className={`cursor-pointer ${
              selectedRowsIds.length ? "text-red-900 " : "text-gray-300"
            } transition-all`}
          />
        </div>
      </TableCell>
    </>
  );
};

const MarketmakingTaskTableAdditionalCol: React.FC<{
  row: IMarketmakingTaskTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isTriggerOpen, setIsTriggerOpen] = useState(false);
  const [previewState, setPreviewState] = useState<IPreviewState>({
    isOpen: false,
    submitFunction: null,
  });
  const [loading, setLoading] = useState(false);
  const [previewOffers, setPreviewOffers] = useState<IGetPreviewOfferResp>(
    {} as IGetPreviewOfferResp
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (previewState.isOpen) fetchPreviewOffers();
  }, [previewState.isOpen]);

  function fetchPreviewOffers() {
    setLoading(true);
    getPreviewOffers(row.id)
      .then((resp) => {
        console.log({ resp });

        setPreviewOffers(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }

  const pauseTaskHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    pauseMarketmakingTasks([row.id])
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const playTaskHandler = () => {
    resumeMarketmakingTasks([row.id])
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
          setPreviewState({ isOpen: false, submitFunction: null });
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const editHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    dispatch(setMarketmakingIsEditFlag(true));
    dispatch(
      setMarketmakingAddTaskFormValues({
        id: row.id,
        accountId: row.userId?.toString(),
        insId: row.optionId,
        threshold: row.threshold,
        volatility: row.volatility,
        baseInsFactor: row.baseInsFactor,
      })
    );
  };

  const resendHandler = () => {
    resendMarketmakingTasks([row.id])
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
          setPreviewState({ isOpen: false, submitFunction: null });
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const triggerTable = useMemo(
    () => (
      <TableTemplate
        TableUI={({ reports }) => <CommonTableUI reports={reports} />}
        getDataTable={getMarketmakingTriggerTable}
        searchParameters={{ taskId: row.id }}
      />
    ),
    [row.id]
  );

  const deleteTaskHandler = () => {
    deleteMarketmakingTasks([row.id])
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const previewOffersHeaders: Header[] = [
    {
      headerName: "calculatedPrice",
      translateHeaderName: "قیمت",
      positionTypeStr: "FirstPage",
      typeStr: "Ltr",
    },
    {
      headerName: "fromVolume",
      translateHeaderName: "از",
      positionTypeStr: "FirstPage",
      typeStr: "Ltr",
    },
    {
      headerName: "toVolume",
      translateHeaderName: "تا",
      positionTypeStr: "FirstPage",
      typeStr: "Ltr",
    },
  ];

  const getPreviewOffersModalUI = () => {
    if (
      previewOffers.buy &&
      previewOffers.sell &&
      previewOffers.buy.length &&
      previewOffers.sell.length
    )
      return (
        <div className="flex flex-col justify-start items-start w-full gap-8">
          <div className="flex flex-row justify-start items-start gap-5 w-full">
            <CommonTableUI
              reports={{
                report: previewOffers.buy?.map((b, i) => ({
                  ...b,
                  id: i,
                  row: i + 1,
                  calculatedPrice: b.calculatedPrice.toFixed(0),
                })),
                translatedHeaders: previewOffersHeaders,
              }}
              tableBoxClassName="big-font-table"
            />
            <CommonTableUI
              reports={{
                report: previewOffers.sell?.map((b, i) => ({
                  ...b,
                  id: i,
                  row: i + 1,
                  calculatedPrice: b.calculatedPrice.toFixed(0),
                })),
                translatedHeaders: previewOffersHeaders,
              }}
              tableBoxClassName="big-font-table"
            />
          </div>
          <div className="mr-auto">
            <Button
              onClick={() => {
                if (previewState.submitFunction) previewState.submitFunction();
              }}
              text="ارسال"
              variant="contained"
            />
          </div>
        </div>
      );
    return <></>;
  };

  return (
    <>
      <TableCell>
        {loading ? <FullScreenLoading /> : <></>}
        {previewState.isOpen ? (
          <Modal
            onClose={() =>
              setPreviewState({ isOpen: false, submitFunction: null })
            }
            UI={getPreviewOffersModalUI()}
            modalBoxClassName="!min-h-[200px]"
          />
        ) : (
          <></>
        )}
        <div
          className="hover:bg-slate-300 transition-all rounded p-1"
          onClick={editHandler}
        >
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        {row.isActive ? (
          <div
            className="hover:bg-slate-300 transition-all rounded p-1"
            onClick={pauseTaskHandler}
          >
            <PauseIcon className="text-sky-700 cursor-pointer" />
          </div>
        ) : null}
        {row.isActive === false ? (
          <div
            className="hover:bg-slate-300 transition-all rounded p-1"
            onClick={() =>
              setPreviewState({ isOpen: true, submitFunction: playTaskHandler })
            }
          >
            <PlayCircleIcon className="text-sky-700 cursor-pointer" />
          </div>
        ) : null}
      </TableCell>
      <TableCell>
        {isTriggerOpen ? (
          <Modal UI={triggerTable} onClose={() => setIsTriggerOpen(false)} />
        ) : (
          <></>
        )}
        <Button
          onClick={() => setIsTriggerOpen(true)}
          className="table-btn"
          text="تریگرها"
          variant="contained"
        />
      </TableCell>
      <TableCell>
        <Button
          onClick={() =>
            setPreviewState({ isOpen: true, submitFunction: resendHandler })
          }
          className="table-btn"
          text="ارسال مجدد"
          variant="contained"
        />
      </TableCell>
      <TableCell>
        <div
          onClick={deleteTaskHandler}
          className="hover:bg-red-100 transition-all rounded p-1"
        >
          <DeleteIcon
            fontSize="small"
            className="text-red-700 cursor-pointer"
          />
        </div>
      </TableCell>
    </>
  );
};

export const MarketmakingTaskTableAdditional: IAdditional<IMarketmakingTaskTableReport> =
  {
    getHeader: MarketmakingTaskTableAdditionalHeader,
    getRow: MarketmakingTaskTableAdditionalCol,
  };
